// @flow

import { useContext } from 'react';
import type { Device } from './types';
import { DeviceContext } from './context';

export function useDevice(): Device {
  const device = useContext(DeviceContext);

  if (!device) {
    throw new Error('DeviceContext was not provided');
  }

  return device;
}
